import PropTypes from "prop-types";
import React from "react";

class Imprint extends React.Component {
  static propTypes = {
    branding: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { branding } = this.props;
    const content = (branding.account.imprint || "").replace(/\n/g, "<br/>");
    return (
      <div style={{ margin: "0 300px" }}>
        <h4>Impressum</h4>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }
}

export default Imprint;
